let detachedSessionResumed = false;

export const markDetachedSessionResumed = (): void => {
  detachedSessionResumed = true;
};

export const isDetachedSessionResumed = (): boolean => detachedSessionResumed;

export const resetDetachedSessionResumed = (): void => {
  detachedSessionResumed = false;
};
